var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaticSensorData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F4F5F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    clipPath: "url(#clip0_110_77074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.6917 33.8335L70.317 45.7501H53.8173L55.192 33.8335H49.6918L48.3171 45.7501H34.8333V51.2503H47.6667L45.778 67.75H34.8333V73.2502H45.1456L43.7709 85.1668H49.2711L50.6459 73.2502H67.1455L65.7708 85.1668H71.2711L72.6458 73.2502H86.166V67.75H73.3326L75.2392 51.2503L86.166 51.251V45.7507H75.8537L77.2284 33.8341L71.6917 33.8335ZM67.7779 67.7495H51.3339L53.2405 51.2498L69.6666 51.2505L67.7779 67.7495Z",
    fill: "#C3C8D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_77074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 77,
    fill: "white",
    transform: "translate(22 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticSensorData);
export default __webpack_public_path__ + "static/media/static_sensor_data.9299884bbe995c276455e8722d3e681d.svg";
export { ForwardRef as ReactComponent };